import { useTheme } from "@hooks";
import { spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    title: {
      marginLeft: spacing.xs,
    },
    subtitle: {
      marginLeft: 32,
      color: theme.text.secondary,
    },
  };

  return styles;
};
